<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">포장배송관리</h2>
          <article>
            <ul class="search_filter">
              <li class="w50">
                <p>한의원명</p>
                <input type="text" v-model="searchInfo.clinic_nm" placeholder="한의원명을 입력하세요" class="form_control" @keyup.enter="fn_search"> 
              </li>
              <li>
                <p style="width:250px">환자명</p>
                <input type="text" v-model="searchInfo.patient_nm" placeholder="환자명을 입력하세요" class="form_control" @keyup.enter="fn_search">
              </li>
              <li>
                <p style="width:250px">처방명/약속상품명</p>
                <input type="text" v-model="searchInfo.prescribe_nm" placeholder="처방명/약속상품명을 입력하세요" class="form_control" @keyup.enter="fn_search">
              </li>
              <li>
                <p>처리상태</p>
                <div class="form_radio">
                  <input type="radio" id="radio1" name="radio"  value="" v-model="searchInfo.pharmacy_status">
                  <label for="radio1">전체</label>
                </div>  
                <div class="form_radio">
                  <input type="radio" id="radio2" name="radio"  value="P3" v-model="searchInfo.pharmacy_status">
                  <label for="radio2">탕전중</label>
                </div>
                <div class="form_radio">
                  <input type="radio" id="radio3" name="radio" value="P5" v-model="searchInfo.pharmacy_status" >
                  <label for="radio3">포장중</label>
                </div>
                <div class="form_radio">
                  <input type="radio" id="radio4" name="radio" value="P6" v-model="searchInfo.pharmacy_status" >
                  <label for="radio4">배송준비</label>
                </div>
                <div class="form_radio">
                  <input type="radio" id="radio5" name="radio" value="P7" v-model="searchInfo.pharmacy_status" >
                  <label for="radio5">배송중</label>
                </div>                                           
              </li>
              <li>
                <p>신청일자</p>
                <Datepicker v-model="searchInfo.startDate" :defaultDate="searchInfo.startDate"/> 
                <span>~</span>
                <Datepicker v-model="searchInfo.endDate" :defaultDate="searchInfo.endDate"/> 
              </li> 
              <li>
                <button class="btn btn_md btn_outline" @click="excelDown">배송다운로드</button>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="list no_view">
              <colgroup>
                <col width="5%">
                <col width="11%">
                <col width="9%">
                <col width="16%">
                <col width="10%">
                <col width="10%">
                <col width="5%">
                <col width="5%">
                <col width="11%">
                <col width="7%">
                <col width="7%">
              </colgroup>
              <thead>
                <tr>
                  <th>
                    <div class="form_checkbox" style="min-width:auto;">
                      <input type="checkbox" :id="'checkboxAll'" v-model="allCheckYn" name="checkboxAll" true-value="Y" false-value="N" @change="fn_all_check()">
                      <label :for="'checkboxAll'"></label>
                      </div>
                  </th>
                  <th>신청일자</th>
                  <th>주문번호</th>
                  <th>처방명</th>
                  <th>한의원명</th>
                  <th>환자명</th>
                  <th>용량</th>
                  <th>첩수</th>
                  <th>송장번호</th>
                  <th>처리</th>
                  <th>복용법</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="wrapperDeliveryList.length == 0">
                    <td colspan="7"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in wrapperDeliveryList" :key="index">
                  <td>
                    <div class="form_checkbox" style="min-width:auto;">
                      <input type="checkbox" :id="'checkbox'+index" name="checkbox" v-model="item.checkBox" true-value="Y" false-value="N" @change="fn_check(item)" :disabled="checkBoxAble(item.work_status)">
                      <label :for="'checkbox'+index"></label>
                    </div>
                  </td>
                  <td><span>{{ item.payment_complete_dt }}</span></td>
                  <td><span>{{ item.prescribe_seq }}</span></td>
                  <td class="al"><span>{{ item.prescribe_nm }}</span><span v-if="item.prescribe_type == 'P'">× {{item.item_quantity}} </span></td>
                  <td><span>{{ item.clinic_nm }}</span></td>
                  <td><span>{{ item.patient_nm }}</span></td>
                  <td><span>{{ item.pack_capacity }}</span></td>
                  <td><span>{{ item.prescribe_pack_cnt }}</span></td>
                  <td>
                    <input type="text" v-if="item.work_status == 'P7'" v-model="item.delivery_no" placeholder="송장번호 입력하세요" class="form_control">
                    <span v-else-if="item.delivery_no != null"> {{item.delivery_no}} </span>
                    <span v-else> - </span>
                  </td>
                  <td>
                    <div class="form_inline">
                      <button v-if="item.work_status === 'P3'" :class="'bdge bd_blue'" @click="fn_change_ststus(item)">탕전중</button>
                      <!-- <button v-else-if="item.work_status === 'P4'" :class="'bdge bd_yellow'" @click="fn_change_ststus(item)">탕전완료</button> -->
                      <button v-else-if="item.work_status === 'P5'" :class="'bdge bd_green'" @click="fn_change_ststus(item)">포장중</button>
                      <button v-else-if="item.work_status === 'P6'" :class="'bdge bd_yellow'" @click="fn_change_ststus(item)">배송준비</button>
                      <button v-else-if="item.work_status === 'P7'" :class="'bdge bd_pupple'" disabled>배송중</button>
                      <button v-if="item.work_status != 'P7'" class="bdge" :disabled="item.prescribe_type == 'P' && item.work_status == 'P5'" @click="fn_prev_ststus(item)"  >취소</button>
                      <button v-if="item.work_status == 'P7'" class="bdge" @click="fn_change_delivery(item)">송장저장</button>
                    <!-- <button v-else></button> -->
                    </div>
                  </td>
                  <td>
                    <div class="form_inline">
                      <button :class="item.howtake_print_yn == 'N' ? 'bdge bd_white' : 'bdge bd_blue'"  v-if="item.howtake_type === 'format'" @click="fn_howTake_print(item)" >복용서출력</button>
                      <button :class="item.howtake_print_yn == 'N' ? 'bdge bd_white' : 'bdge bd_pupple'"  v-else-if="item.howtake_type === 'file'" @click="fn_download_click(item)">복용서다운</button>
                      <button v-else-if="item.prescribe_type === 'P'" :class="'bdge bd_yellow'" @click="fn_print_modal_open(item.prescribe_seq, item.prescribe_type)">처방전</button>
                      <span v-else> - </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo="searchInfo.pageInfo" @clickPage="fn_move_pharmacy" v-show="pagingShow"/>
          </div>
        </section>
      </div>
      <howTakePrintModal
            :application="application"
            :data="howTake"
            :printView="false"
            />
      <promisePrescriptModal
          :title="'조제신청서'"
          :prescribe_seq="selectPrescribeSeq"
      />
    </div>
</template>

<script>
  import axios from 'axios'  
  import Pagination from "@/components/AdminPagination.vue"
  import Datepicker from '@/components/Datepicker.vue'
  import howTakePrintModal from "@/modal/common/howTakePrintModal.vue"
  import commonUtil from "@/mixin/commonUtil";
  import * as XLSX from 'xlsx'

  import { 
      format,
      count,
      time,
      temperature,
      forbidden
  } from '@/data/user/takingData'
  import promisePrescriptModal from "@/modal/admin/promisePrescriptModal.vue";

  export default {
    name: 'pharmacyMngt',
    mixins: [commonUtil],
    components: {    
      Pagination,
      Datepicker,
      howTakePrintModal,
      promisePrescriptModal
    },
    data() {
      return {
        searchInfo : {
          prescribe_nm : '',
          clinic_nm : '',
          patient_nm : '',
          pharmacy_status : '',
          startDate : '',
          endDate : '',
          pageInfo : {
            page : 1,
            pageSize : 10,
            totPage : 0
          }               
        },
        pagingShow : false,
        wrapperDeliveryList : [],
        selected: null,
        selectPrescribeSeq : 0,
        allCheckYn : 'N',
        deliveryList : [],
        excel: [],
        application : {
          prescribe_seq : '',
          patient_name : '',
          clinic_nm : '',
          howTake_clinic_name : '',
          howTake_clinic_tel : '',
          howTake_clinic_address : '',
        },
        //복용법관련 데이터
        howTake: [
            { th : '복용법', require: true, data: format , selected: '', label: '', etcMsg: '', mode : 'upload'},
            { th : '복용 횟수', require: false, data: count , selected: '', label: '', etcMsg: '' },
            { th : '복용 시간', require: false, data: time , selected: '', label: '', etcMsg: '' },
            { th : '복용 온도', require: false , data: temperature, selected: '', label: '', etcMsg: '' },
            { th : '금할 음식', require: true, data: forbidden , selected: [], label: '', etcMsg: '' , mode: 'select'}
        ],
        checkableTaskList : ['P1','P2','P3','P4','P8','P9']  //포장중, 배송준비, 배송중 제외
      }
    },
    created(){
      this.fn_search();
    },
    methods : {
      fn_search(){

        axios
            .post("/api/admin/work/getWrapperDeliveryList", this.searchInfo)
            .then((res) => {

                this.wrapperDeliveryList = res.data.wrapperDeliveryList;

                console.log("@@@@ WrapperDelivery : %o",this.wrapperDeliveryList);

                this.searchInfo.pageInfo.totPage = res.data.totCnt;
                
                if(this.searchInfo.pageInfo.totPage> 0){
                    this.pagingShow = true;                          
                } 
                
                this.allCheckYn = 'N';

                if(this.deliveryList.length >  0){

                  //화면 리스트에 있는 정보에서 기존 체크 여부 확인
                  const checkedIds = new Set(this.deliveryList.map(x => x.prescribe_seq));

                  //배송에 체크가 되어 있는 정보 체크 처리
                  this.wrapperDeliveryList.forEach(x => {
                      if (checkedIds.has(x.prescribe_seq)) {
                        x.checkBox = 'Y';
                      }
                    });
                }

            })
            .catch((err) => console.log(err));
        },
      fn_move_pharmacy(page){
        this.searchInfo.pageInfo.page = page;
        this.fn_search();
      },
      //print 모달 호출
      fn_print_modal_open(prescribe_seq, prescribe_type){
        this.selectPrescribeSeq = prescribe_seq;

        this.$nextTick(() => {
          if(prescribe_type != 'P'){
            this.$bvModal.show("workingModal");
          }else{
            this.$bvModal.show("promisePrescriptModal");
          }
        });

      },
      fn_change_ststus(item){
        
        let changeStatus = "";

        if(item.work_status == 'P3'){
          changeStatus = "P5";        //포장중
        }
        //  else if(item.work_status == 'P4'){
        //   changeStatus = "P5";        //포장중
        //  }
        else if(item.work_status == 'P5'){
          changeStatus = "P6";        //배송준비중
        }else if(item.work_status == 'P6'){
          changeStatus = "P7";        //배송중
        }
         

        // if(item.work_status == 'PA'){
        //   changeStatus = "PNG";
        // }else if(item.work_status == 'PNG'){
        //   changeStatus = "PC";
        // }

        // console.log("@@@@@ item.prescribe_seq : "+item.prescribe_seq);
        // console.log("@@@@@ changeStatus : "+changeStatus);

        let param = {prescribe_seq : item.prescribe_seq, work_status : changeStatus}

        axios
            .post("/api/admin/work/updatePrescribeStatus", param)
            .then((res) => {
                console.log("@@@@ res : %o",res);
                
                this.fn_search();

            })
            .catch((err) => console.log(err));
      },
      fn_howTake_print(item){

        //복용법 기본 정보 셋팅
        this.application.prescribe_seq = item.prescribe_seq;
        this.application.patient_name = item.patient_nm;
        this.application.clinic_nm = item.clinic_nm;
        this.application.howTake_clinic_name = item.howTake_clinic_name;
        this.application.howTake_clinic_tel = item.howTake_clinic_tel;
        this.application.howTake_clinic_address = item.howTake_clinic_address;

        console.log('@@@@@ count : %o',count);

        this.howTake[1].selected = item.howtake_count;
        for(let i = 0; i < count.length; i++){
          if(item.howtake_count != 'etc' && item.howtake_count == count[i].value){
            this.howTake[1].label = count[i].text;
          }else if(item.howtake_count == 'etc'){
            this.howTake[1].etcMsg = item.howtake_count_etc;
          }
        }

        this.howTake[2].selected = item.howtake_time;
        for(let i = 0; i < time.length; i++){
          if(item.howtake_time != 'etc' && item.howtake_time == time[i].value){
            this.howTake[2].label = time[i].text;
          }else if(item.howtake_time == 'etc'){
            this.howTake[2].etcMsg = item.howtake_time_etc;
          }
        }

         for(let i = 0; i < temperature.length; i++){
          if(item.howtake_temperature == temperature[i].value){
            this.howTake[3].label = temperature[i].text;
          }
        }

        let textTemp = '';
        if(item.howtake_forbidden != null && item.howtake_forbidden !=''){
          let forbiddenList =  item.howtake_forbidden.split(',');

          for(let j = 0; j < forbiddenList.length; j++){
            if(forbiddenList[j] != 'etc'){
              for(let i = 0; i < forbidden.length; i++){
                if(forbiddenList[j]== forbidden[i].value){
                  if(textTemp == ''){
                    textTemp = forbidden[i].text;
                  }else{
                    textTemp = textTemp +', '+forbidden[i].text;
                  }
                }
              }
            }else{
              textTemp = forbidden[10].text;
              this.howTake[4].etcMsg = item.howtake_forbidden_etc;
            }
        }


          this.howTake[4].label = textTemp;

        } 

        console.log("@@@@@ howTake : %o",this.howTake);
        
        this.$bvModal.show("howTakePrintModal"); 
        
      },
      fn_download_click(item){

        console.log("@@@@@ 출력");
        axios
            .post("/api/admin/work/updatePrintStatus", item)
            .then((res) => {
                console.log("@@@@ res : %o",res);
                item.howtake_print_yn = 'Y'
            })
            .catch((err) => console.log(err));

        this.fn_download_file(item.howtake_file_id);
      },
      fn_check(item){

        if(item.checkBox == 'Y'){
          this.deliveryList.push(item);
        }else{

          // 체크항복 제거
          this.deliveryList = this.deliveryList.filter(x => x.prescribe_seq !== item.prescribe_seq);
        }

        console.log("@@@@@ this.deliveryList : %o",this.deliveryList);
      },
      fn_all_check(){
        
        if(this.allCheckYn == 'Y'){

            //현재 체크되어 있는 배송정보
            const checkedIds = new Set(this.deliveryList.map(x => x.prescribe_seq));

            this.wrapperDeliveryList.forEach(x => {
                if (!this.checkBoxAble(x.work_status)) {
                  x.checkBox = 'Y';
                }
              });

            const canSelect = (x) => !this.checkBoxAble(x.work_status);  // 배송준비인 경우만 체크(함수의 매개변수(parameter))

            //전체체크로 추가되는 정보
            const newlyAdded = this.wrapperDeliveryList
                                      .filter(x => !checkedIds.has(x.prescribe_seq))  // 전체 중 새로 추가될 것
                                      .filter(canSelect)  
                                      .map(x => ({
                                        ...x,
                                        checkBox: 'Y'  //조건이면 Y, 아니면 유지/또는 N
                                      }));

          this.deliveryList = this.deliveryList.concat(newlyAdded);  // 체크리스트에 추가

        }else{


          //현재 화면에 보이는 배송정보
          const checkedIds = new Set(this.wrapperDeliveryList.map(x => x.prescribe_seq));

          // 체크항복 제거 (화면에 없는 배송정보)
          this.deliveryList = this.deliveryList.filter(x => !checkedIds.has(x.prescribe_seq));

          //화면의 체크정보 체크 해제
          this.wrapperDeliveryList.forEach(x => {
              x.checkBox = 'N';
          });
        }

        console.log("@@@@@ this.deliveryList : %o",this.deliveryList);
      },
      excelDown() {

        if(this.deliveryList.length > 0){
          for (const excel of this.deliveryList) {
            const excelLogs = {
              주문자: '',
              주문자우편번호: '',
              주문자주소: '',
              주문자연락처1: '',
              수령인: '',
              수령인우편번호: '',
              수령인주소: '',
              수령인핸드폰: '',
              수령인전화번호: '',
              배송메모: '',
            };
            excelLogs.주문자 = excel.send_nm;
            excelLogs.주문자우편번호 = excel.send_post_no;
            excelLogs.주문자주소 = excel.send_addr+' '+excel.send_addr_dtl;
            excelLogs.주문자연락처1 = excel.send_tel_num;
            excelLogs.수령인 = excel.receive_nm;
            excelLogs.수령인우편번호 = excel.receive_post_no;
            excelLogs.수령인주소 = excel.receive_addr+' '+excel.receive_addr_dtl;
            excelLogs.수령인핸드폰 = excel.receive_phone_num;
            excelLogs.수령인전화번호 = excel.receive_tel_num;
            excelLogs.배송메모 = excel.delivery_memo;

            this.excel.push(excelLogs);
          }

          console.log("@@@@ this.excel : %o",this.excel);
          
          // 엑셀의 workbook(엑셀파일에 지정된 이름)을 만든다
          const wb = XLSX.utils.book_new();
          //엑셀 워크시트로 json 내보내기, 배열만 가능
          const dataWS = XLSX.utils.json_to_sheet(this.excel);
          // workbook에 워크시트 추가, 시트명은 'peopleData'
          XLSX.utils.book_append_sheet(wb, dataWS, 'deliveryData');
          // 엑셀 파일을 내보낸다. 엑셀 파일 저장명은 'people.xlsx'
          XLSX.writeFile(wb, 'deliveryData.xlsx');
        }else {
          alert("배송 다운로드할 데이터를 체크해주세요");
        }

        

      },
      fn_change_delivery(item){
        console.log("item : %o",item);
        if(item.delivery_no == null || item.delivery_no == ''){
          alert("송장번호를 입력하세요");
          return;
        }

        axios
            .post("/api/admin/work/updateDeliveryNumber", item)
            .then((res) => {
                console.log("@@@@ res : %o",res);
                alert("송장번호가 저장되었습니다");
                this.fn_search();
            })
            .catch((err) => console.log(err));
      },
      fn_prev_ststus(item){

        let prev_process = "";

        if(item.work_status != 'P5'){
          let last_process = item.work_status.substr(item.work_status.length-1, 1);
          let prev_process_num = Number(last_process) - 1;
          prev_process = 'P'+prev_process_num;
        }else{
          if(item.prescribe_type == 'P'){
            //약속상품인 경우 조제접수
            prev_process = 'P1';        //조제접수
          }else{
            prev_process = 'P3';        //탕전중
          }

        }
      
        

        let param = {prescribe_seq : item.prescribe_seq, work_status : prev_process}

        axios
          .post("/api/admin/work/updatePrescribeStatus", param)
          .then((res) => {
              console.log("@@@@ res : %o",res);
              
              this.fn_search();

          })
          .catch((err) => console.log(err));
      },
      checkBoxAble(value) {
        return this.checkableTaskList.includes(value);
      },

      
    },
  }
</script>
